export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgVisbility = require("../assets/visibility.svg");
export const imgVisbilityOff = require("../assets/visibilityOff.svg");
export const deamond = require("../assets/deamond.png");
export const loyaltyIcon = require("../assets/loyaltyPoint.png");
// export const goldenPointsIcon = require("../assets/goldenPoint.png");

